import React from 'react';
import rocketBackground from '../assets/rocket_bp_bkg.png';

interface SimpleLoginPageProps {
  onLogin: () => void;
}

const SimpleLoginPage: React.FC<SimpleLoginPageProps> = ({ onLogin: _onLogin }) => {
  const handleSignIn = () => {
    window.location.href = '/api/auth/login/';
  };

  return (
    <div 
      className="min-h-screen flex items-center bg-cover bg-center bg-no-repeat relative bg-indigo-900"
      style={{
        backgroundImage: `url(${rocketBackground})`
      }}
    >
      {/* Overlay for better readability */}
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      
      <div className="relative z-10 bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md backdrop-blur-sm bg-opacity-95 ml-32">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Catalyx <span className="text-indigo-600">Canvas</span>
          </h1>
          <p className="text-gray-600">Welcome back! Please sign in to continue</p>
        </div>

        <button
          onClick={handleSignIn}
          className="w-full bg-indigo-600 text-white py-3 rounded-lg font-medium hover:bg-indigo-700 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-all disabled:bg-indigo-400 disabled:cursor-not-allowed"
        >
          Sign In
        </button>

        <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
          <p className="text-sm text-blue-800">
            <strong>Note:</strong> Only pre-authorized users can access this platform. 
            If you don't have access, please contact us at teamops@thecatalyx.com.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SimpleLoginPage;